document.addEventListener("DOMContentLoaded", function () {

    // const pageMain = document.querySelector(".page-custom-main");
    // if (!pageMain) return;

    // const h2s = pageMain.querySelectorAll("h2");
    // if (!h2s.length) return;

    // const targetH2 = h2s[h2s.length - 1]; // last h2 only

    // if (!targetH2.textContent.trim().toLowerCase().includes("book")) return;

    // // Collect all <a> after that h2
    // const links = [];
    // let el = targetH2.nextElementSibling;

    // while (el) {
    //     links.push(...el.querySelectorAll("a"));
    //     if (el.tagName === "A") links.push(el);
    //     el = el.nextElementSibling;
    // }

    // if (!links.length) return;

    // // Build new layout
    // const container = document.createElement("div");
    // container.className = "buttons-container";

    // container.innerHTML = `
    //     <h2>${targetH2.textContent}</h2>
    //     <div class="appointment-wrapper"></div>
    //     <div class="links-wrapper"></div>
    // `;

    // const appointment = container.querySelector(".appointment-wrapper");
    // const others = container.querySelector(".links-wrapper");

    // links.forEach((a, i) => {
    //     const clone = a.cloneNode(true);
    //     if (i < 2) appointment.appendChild(clone);
    //     else others.appendChild(clone);
    // });

    // // Remove original content
    // let remove = targetH2.nextElementSibling;
    // while (remove) {
    //     let next = remove.nextElementSibling;
    //     remove.remove();
    //     remove = next;
    // }

    // targetH2.remove();

    // // Insert rebuilt block after pageMain
    // pageMain.insertAdjacentElement("afterend", container);

    const accordions = document.querySelectorAll(".tv-accordion");
    if(accordions.length) {
        accordions.forEach(function(accordion) {
            accordion.addEventListener("click", function () {
                this.classList.toggle("active");
            });
        });
    }
});
